// state
import type { RootState } from 'src/state';

// material
import { useSelector } from 'react-redux';

import Button from '@mui/material/Button';

import { useDispatch } from 'src/state';
// hooks
import { useTranslate } from 'src/locales';
import { selectUser } from 'src/state/user/selectors';
import { createStripeCheckoutSession } from 'src/state/subscription/actions';

// ----------------------------------------------------------------------

export default function SubscriptionUpgradeButton() {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const displayInterval = useSelector((state: RootState) => state.subscription.displayInterval);
  const paymentProvider = useSelector((state: RootState) => state.subscription.paymentProvider);

  const handleClick = () => {
    if (paymentProvider === 'fastspring') {
      // Legacy FastSpring checkout
      if ((window as any).fastspring && (window as any).fastspring.builder) {
        (window as any).fastspring?.builder?.reset();
        (window as any).fastspring?.builder?.add(
          displayInterval === 'monthly' ? 'pro' : 'pro-yearly'
        );
        (window as any).fastspring?.builder?.tag({ userId: user?.id });
        (window as any).fastspring?.builder?.recognize({
          email: user?.email,
          firstName: user?.firstName,
          lastName: user?.lastName,
          userId: user?.id,
        });
        (window as any).fastspring?.builder?.checkout();
      }
      return;
    }

    dispatch(createStripeCheckoutSession(displayInterval === 'yearly' ? 'pro-yearly' : 'pro'));
  };

  return (
    <Button variant="contained" fullWidth onClick={handleClick}>
      {t('Subscribe')}
    </Button>
  );
}
